import { getUser } from '@/services/auth/user'
import { impersonate as impersonateRequest } from '@/services/user/userService'

const STORAGE_KEYS = {
  USER_TYPE: 'user_type',
  ACCESS_ROLES: 'access_roles',
  ACCESS_TOKEN: 'access_token',
  IMPERSONATOR_TOKEN: 'impersonator_token',
  BACKUP_ACCESS_TOKEN: 'backup_access_token',
}

function validateAndDecodeJWT(token, errorContext = 'JWT validation') {
  if (!token) {
    console.error(`${errorContext}: Token not provided`)
    return null
  }

  try {
    const tokenParts = token.split('.')
    if (tokenParts.length !== 3) throw new Error('Invalid JWT token format')
    return JSON.parse(window.atob(tokenParts[1]))
  } catch (error) {
    console.error(`${errorContext}: Error decoding JWT token:`, error)
    return null
  }
}

function getCurrentAccessTokenAndSave() {
  const accessToken = localStorage.getItem(STORAGE_KEYS.ACCESS_TOKEN)
  localStorage.setItem(STORAGE_KEYS.BACKUP_ACCESS_TOKEN, accessToken)
}

function setAccessTokenFromBackupAndSetData() {
  const accessToken = localStorage.getItem(STORAGE_KEYS.BACKUP_ACCESS_TOKEN)
  const jwt = validateAndDecodeJWT(accessToken, 'Backup token validation')

  if (!jwt) return

  localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, accessToken)
  localStorage.setItem(STORAGE_KEYS.USER_TYPE, jwt?.userType)
  localStorage.setItem(STORAGE_KEYS.ACCESS_ROLES, jwt.authorities)
}

export const impersonate = async (userId) => {
  try {
    getCurrentAccessTokenAndSave()

    const {data} = await impersonateRequest({user_id: userId})
    const jwt = validateAndDecodeJWT(data.token, 'Impersonate token validation')

    if (!jwt) throw new Error('Failed to validate impersonate token')

    localStorage.setItem(STORAGE_KEYS.ACCESS_TOKEN, data.token)
    localStorage.setItem(STORAGE_KEYS.USER_TYPE, jwt?.userType)
    localStorage.setItem(STORAGE_KEYS.ACCESS_ROLES, jwt.authorities)
    localStorage.setItem(STORAGE_KEYS.IMPERSONATOR_TOKEN, jwt?.impersonator_token)

    await getUser()
  } catch (error) {
    console.error(error)
  }
}

export const revertImpersonate = async () => {
  try {
    setAccessTokenFromBackupAndSetData()

    // clear impersonate stuff
    localStorage.removeItem(STORAGE_KEYS.IMPERSONATOR_TOKEN)
    localStorage.removeItem(STORAGE_KEYS.BACKUP_ACCESS_TOKEN)

    await getUser()
  } catch (error) {
    console.error(error)
  }
}

export const isUserImpersonated = () => localStorage.getItem(STORAGE_KEYS.IMPERSONATOR_TOKEN)
